import {
  IsNotEmpty,
  IsUUID,
  IsOptional,
  IsDateString,
  IsInt,
  IsBoolean,
  Min,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { Type } from 'class-transformer'

export class CreateActivityUserAssignmentDto {
  @ApiProperty({
    description: "UUID de l'activité",
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsNotEmpty()
  @IsUUID('4')
  activityId!: string

  @ApiProperty({
    description: "UUID de l'utilisateur assigné",
    example: '660e8400-e29b-41d4-a716-446655440001',
  })
  @IsNotEmpty()
  @IsUUID('4')
  userId!: string

  @ApiPropertyOptional({
    description: 'Date de disponibilité (ISO 8601)',
    example: '2024-11-01T00:00:00Z',
  })
  @IsOptional()
  @IsDateString()
  availableFrom?: string

  @ApiPropertyOptional({
    description: "Date d'échéance (ISO 8601)",
    example: '2024-11-30T23:59:59Z',
  })
  @IsOptional()
  @IsDateString()
  dueAt?: string

  @ApiPropertyOptional({
    description: 'Nombre maximum de tentatives',
    example: 3,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  maxAttempts?: number

  @ApiPropertyOptional({
    description: 'Afficher les solutions après soumission',
    default: false,
  })
  @IsOptional()
  @IsBoolean()
  showSolutions?: boolean
}
